<template>
  <a-modal wrap-class-name="operation-feedback-wrap" :visible="visible" :title="dialog?.title" :footer="null" :closable="false" :mask-closable="false" :keyboard="false" :focus-trigger-after-close="false" :width="480" centered :after-close="finish">
    <FeedbackContent v-if="dialog" :content="dialog.content" />
    <div class="operation-feedback-actions"><a-button type="primary" @click="confirm">{{dialog?.okText || '我知道了'}}</a-button></div>
  </a-modal>
</template>
<script lang="ts">
import {defineComponent} from 'vue'
import {operationDialog,operationDialogVisible,confirmOperationDialog,finishOperationDialog} from '@/utils/operationDialog'
const FeedbackContent=defineComponent({props:['content'],setup:props=>()=>props.content})
export default defineComponent({components:{FeedbackContent},setup(){return {dialog:operationDialog,visible:operationDialogVisible,confirm:confirmOperationDialog,finish:finishOperationDialog}}})
</script>
<style scoped>
.operation-feedback-actions{display:flex;justify-content:flex-end;margin-top:24px}
</style>
